<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Динамичные типы бизнеса</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="flex flex-row-reverse">
                        <CButton
                            v-if="adminOnly"
                            class="mb-2"
                            color="primary"
                            @click="$router.push('/settings/entities/create')"
                        >Создать</CButton>
                    </div>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-16"></div>
                            <div class="w-2/5 py-2 font-bold">Название</div>
                        </div>
                        <div
                            v-for="item in list"
                            :key="item.id"
                            class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
                        >
                            <div class="w-16"></div>
                            <div class="w-2/5">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${item.id}`)">
                                    {{ item.title }}
                                </span>
                            </div>
                        </div>
                    </div>
                </CCardBody>

                <CCardFooter v-if="adminOnly">
                    <CButton
                        color="primary"
                        @click="$router.push('/settings/entities/create')"
                    >Создать</CButton>
                </CCardFooter>
            </CCard>
            <CCard>
                <CCardHeader>
                    <strong>Статичные типы бизнеса</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="overflow-hidden border border-gray-300 rounded-md mt-2">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-16"></div>
                            <div class="w-2/5 py-2 font-bold">Название</div>
                        </div>
                        <div
                            v-for="(item, index) in staticList"
                            :key="index"
                            class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
                        >
                            <div class="w-16"></div>
                            <div class="w-2/5">
                                <span
                                    :class="`text-purple-700 cursor-pointer hover:underline ${item.disabled ? 'disabled' : ''}`"
                                    @click="item.disabled ? () => false : $router.push(`/settings/${item.link}`)"
                                >
                                    {{ item.label }} {{ item.disabled ? item.warnText : '' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import { STATIC_SERVICES_LIST } from '@/utils/settings-vars';

    export default {
        name: 'EntitiesTypeSettings',

        data: () => ({
            list: [],
            staticList: STATIC_SERVICES_LIST,
        }),

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                try {
                    const { data } = await this.axios.get('/entities-type')
                    this.list = data
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .disabled {
        color: #8a93a2;
        &:hover {
            text-decoration: none;
            cursor: inherit;
        }
    }
</style>
